import { Directive } from '@angular/core';

@Directive({
    selector: '[mcMcFormField]',
    standalone: false
})
export class McFormFieldDirective {

  constructor() { }

}
